import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import { Badge } from '@tinyrewards/shared';
import { getBadge } from '../api/badges';
import CreateBadgePage from './CreateBadgePage';

export default function BadgeEditLoader() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [badge, setBadge] = useState<Badge | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!id) {
            setError('Invalid badge id.');
            setLoading(false);
            return;
        }
        setLoading(true);
        getBadge(id)
            .then(res => {
                if (res.success && res.data) {
                    setBadge(res.data);
                } else {
                    setError(res.message ?? 'Badge not found or you do not have permission to edit it.');
                }
            })
            .catch(() => setError('Failed to load badge.'))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" py={8}>
                <CircularProgress />
            </Box>
        );
    }

    if (error || !badge) {
        return (
            <Container maxWidth="md" sx={{ py: 4 }}>
                <Alert severity="error" action={
                    <Box component="a" onClick={() => navigate('/badges')} sx={{ cursor: 'pointer' }}>
                        Back to badges
                    </Box>
                }>
                    {error ?? 'Badge not found.'}
                </Alert>
            </Container>
        );
    }

    return <CreateBadgePage initialBadge={badge} />;
}
